import Alpine from 'alpinejs';
import svgPanZoom from 'svg-pan-zoom';

Alpine.data('map', () => ({
    map: null,
    countrySelected: null,
    citySelected: null,
    forCountry: null,
    zoom: 2,
    init() {
        const map = new svgPanZoom(this.$root.querySelector('svg'), {
            zoomEnabled: true,
            zoomScaleSensitivity: 0.5,
            controlIconsEnabled: false,
            dblClickZoomEnabled: false,
            mouseWheelZoomEnabled: false,
            fit: 1,
            center: 1,
            minZoom: 2,
            maxZoom: 20,
        });
        this.map = map;
        this.zoomToEurope();

        const selectable = this.$root.querySelector('.map__selectable');
        // we only want to trigger click event if the user didn't drag the map
        let startX = 0;
        let startY = 0;
        selectable.addEventListener('mousedown', (e) => {
            startX = e.clientX;
            startY = e.clientY;
        });
        selectable.addEventListener('mouseup', (e) => {
            const diff = Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY);
            if (diff < 3) {
                this.onSelectableClick(e);
            }
        });
        selectable.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });
        selectable.addEventListener('touchend', (e) => {
            const diff =
                Math.abs(e.changedTouches[0].clientX - startX) + Math.abs(e.changedTouches[0].clientY - startY);
            if (diff < 3) {
                this.onSelectableClick(e);
            }
        });

        selectable.addEventListener('mouseover', (e) => this.onSelectableHover(e));
        selectable.addEventListener('mouseout', () => this.unsetHoverStates());

        window.addEventListener('selectCountry', ($event) => {
            const { country } = $event.detail;
            this.selectCountryById(country);
        });
        window.addEventListener('selectCity', ($event) => {
            const { country, city, forCountry } = $event.detail;
            this.selectCityById(country, city);
            if (forCountry && forCountry !== country) {
                this.forCountry = forCountry;
            }
            this.scrollToTabsContent();
        });
    },
    onSelectableClick(e) {
        let targetCountry = e.target.closest('.country');
        if (targetCountry) {
            this.selectCountry(targetCountry);
            this.scrollToTabsContent();
            return;
        }
        let targetCity = e.target.closest('.city');
        if (targetCity) {
            this.unsetSelection();
            let targetCountry = this.$root.querySelector(
                `.map__selectable .country[data-country-id="${targetCity.getAttribute('data-country-id')}"]`
            );
            this.selectCity(targetCountry, targetCity);
            this.scrollToTabsContent();
        }
    },
    selectCountryById(countryId) {
        this.forCountry = null;
        let targetCountry = this.$root.querySelector(`.map__selectable .country[data-country-id="${countryId}"]`);
        this.selectCountry(targetCountry);
        this.zoomToCountry();
    },
    selectCountry(targetCountry) {
        this.forCountry = null;
        this.unsetSelection();
        if (!targetCountry) {
            return;
        }
        this.countrySelected = targetCountry.getAttribute('data-country-id');
        targetCountry.dataset.selected = 'true';
        let targetCities = this.$root.querySelector(
            `.map__selectable .cities[data-country-id="${this.countrySelected}"]`
        );
        targetCities.dataset.countrySelected = 'true';
    },
    selectCityById(countryId, cityId) {
        this.forCountry = null;
        let targetCountry = this.$root.querySelector(`.map__selectable .country[data-country-id="${countryId}"]`);
        let targetCity = this.$root.querySelector(`.map__selectable .city[data-city-id="${cityId}"]`);
        this.selectCity(targetCountry, targetCity);
        this.zoomToCountry();
    },
    selectCity(targetCountry, targetCity) {
        this.forCountry = null;
        if (!targetCountry || !targetCity) {
            return;
        }
        this.selectCountry(targetCountry, false);
        this.citySelected = targetCity.getAttribute('data-city-id');
        targetCity.dataset.selected = 'true';
    },
    scrollToTabsContent() {
        const el = this.$root.querySelector('.map__tabs-content-scroll-position');
        const header = document.querySelector('.header');
        let headerHeight = 0;
        if (header && window.matchMedia('(min-width: 64rem)').matches) {
            headerHeight = header.getBoundingClientRect().top + header.getBoundingClientRect().height;
        }
        const y = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scroll({
            top: y,
            behavior: 'smooth',
        });
    },
    unsetHoverStates() {
        Array.from(this.$root.querySelectorAll('.map__selectable .country[data-hover="true"]')).forEach((item) => {
            item.dataset.hover = 'false';
        });
        Array.from(this.$root.querySelectorAll('.map__selectable .cities[data-country-hover="true"]')).forEach(
            (item) => {
                item.dataset.countryHover = 'false';
            }
        );
    },
    onSelectableHover(e) {
        let targetCountry = e.target.closest('.country');
        if (targetCountry) {
            let hoverCountryId = targetCountry.getAttribute('data-country-id');
            let hoverCities = this.$root.querySelector(`.map__selectable .cities[data-country-id="${hoverCountryId}"]`);
            hoverCities.dataset.countryHover = 'true';
        }

        let targetCity = e.target.closest('.city');
        if (targetCity) {
            let hoverCountryId = targetCity.getAttribute('data-country-id');
            let hoverCountry = this.$root.querySelector(
                `.map__selectable .country[data-country-id="${hoverCountryId}"]`
            );
            let hoverCities = this.$root.querySelector(`.map__selectable .cities[data-country-id="${hoverCountryId}"]`);
            hoverCities.dataset.countryHover = 'true';
            hoverCountry.dataset.hover = 'true';
        }
    },
    unsetSelection() {
        this.countrySelected = null;
        let previousSelectedCountry = this.$root.querySelector('.map__selectable .country[data-selected="true"]');
        if (previousSelectedCountry) {
            previousSelectedCountry.dataset.selected = 'false';
        }
        this.citySelected = null;
        let previousSelectedCities = this.$root.querySelector('.map__selectable .cities[data-country-selected="true"]');
        if (previousSelectedCities) {
            previousSelectedCities.dataset.countrySelected = 'false';
        }
        let previousSelectedCity = this.$root.querySelector('.map__selectable .city[data-selected="true"]');
        if (previousSelectedCity) {
            previousSelectedCity.dataset.selected = 'false';
        }
    },
    animateMove(zoomAndPanCallback) {
        this.$root.classList.add('map--is-animated');
        zoomAndPanCallback();
        this.zoom = this.map.getZoom();
        setTimeout(() => {
            this.$root.classList.remove('map--is-animated');
        }, 300);
    },
    zoomIn() {
        this.animateMove(() => {
            this.map.zoomIn();
        });
    },
    zoomOut() {
        this.animateMove(() => {
            this.map.zoomOut();
        });
    },
    zoomToEurope() {
        this.animateMove(() => {
            let ukBbox = this.$root.querySelector('.country[data-country-id="UnitedKingdom"] .field').getBBox();
            let serbiaBbox = this.$root.querySelector('.country[data-country-id="Serbia"] .field').getBBox();
            let ukraineBbox = this.$root.querySelector('.country[data-country-id="Ukraine"] .field').getBBox();
            this.focusOn(
                {
                    x: ukBbox.x,
                    y: ukBbox.y,
                    width: ukraineBbox.x - ukBbox.x + ukraineBbox.width,
                    height: serbiaBbox.y - ukBbox.y + serbiaBbox.width,
                },
                8
            );
        });
    },
    zoomToCountry() {
        if (!this.countrySelected) {
            return;
        }

        const zoom = this.countrySelected === 'China' ? 5 : 15;
        this.animateMove(() => {
            this.focusOnElement(
                this.$root.querySelector(`.country[data-country-id="${this.countrySelected}"] .field`),
                zoom
            );
        });
    },
    focusOnElement(el, zoom) {
        this.focusOn(el.getBBox(), zoom);
    },
    focusOn(bbox, zoom) {
        // taken from https://github.com/bumbu/svg-pan-zoom/issues/381
        // just the zoom doesn't work properly

        // pan so the el is at the center
        const { width, height, realZoom } = this.map.getSizes();
        this.map.pan({
            x: -realZoom * (bbox.x - width / (realZoom * 2) + bbox.width / 2),
            y: -realZoom * (bbox.y - height / (realZoom * 2) + bbox.height / 2),
        });

        // we want to zoom in to see just around the el -
        //const relativeZoom = this.map.getZoom();
        //const desiredWidth = 50 * Math.sqrt(bbox.width / 25) * 11 * realZoom;
        //this.map.zoom((relativeZoom * width) / desiredWidth);
        this.map.zoom(zoom);
    },
}));
